import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EnvironmentUtilService } from '../../util';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class ChannelProductMappingApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getProducts(params ?:{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/manage/channels/products`,
      { params },
    );
  }

  getInventoryLocationsByChannel(data :{
    params ?:{
      [param :string] :string | string[];
    };
    url :string;
  }) :Observable<any> {
    const { params, url } = data;

    return this.apiService.get(`${this.environment.urlV2}/${url}`, { params });
  }

  downloadProductsToExcel(params ?:{
    [param :string] :string | string[];
  }) :Observable<any> {
    const headers = new HttpHeaders({
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    return this.apiService.getBlob(
      `${this.environment.urlV2}/manage/channels/products`,
      { params, headers },
    );
  }

  getProductsUnified(data :{
    url :string;
    params ?:{
      [param :string] :string | string[];
    };
  }) :Observable<any> {
    const { url, params } = data;

    return this.apiService.get(`${this.environment.urlV2}${url}`, { params });
  }
  getProductsV2(params ?:{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/manage/channels/v2/products`,
      { params },
    );
  }

  saveChannelProductOverride(
    appIntegrationAccountProductId :number,
    params ?:{ [param :string] :string | string[] },
  ) :Observable<any> {
    return this.apiService.put(
      `${this.environment.urlV2}/manage/channels/v2/products/${appIntegrationAccountProductId}`,
      params,
    );
  }

  mapSku(data :{ id :number; rfqId :number }) :Observable<any> {
    return this.apiService.put(
      `${this.environment.urlV2}/manage/channels/products/${data.id}`,
      data,
    );
  }

  updateRow(
    id :number,
    data ?:{
      [param :string] :string | string[] | boolean;
    },
  ) :Observable<any> {
    return this.apiService.put(
      `${this.environment.urlV2}/manage/channels/products/${id}`,
      data,
    );
  }

  pushUpdates(payload :{
    items :{
      channelId :number;
      productIds :number[];
    }[];
  }) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/integration/channel-products/oms-push`,
      body: payload,
    });
  }

  pushAllProducts(channelId ?:number) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/integration/channel-products/oms-push-all`,
      body: {
        channelId,
      },
    });
  }
}
